import { Injectable } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";

export type SeoConfig = {
    //"og:site_name": string
    title?: string;
    // Common Tags
    subtitle?: string;
    description?: string;
    url?: string;
    "og:title"?: string;
    "og:description"?: string;
    "og:url"?: string;
    keywords?: string[];
    subject?: string;
    topic?: string;
    summary?: string;

    // Detailed Property Tag
    "og:image"?: string;
    // Detailed Property Tag
    "og:latitude"?: string;
    // Detailed Property Tag
    "og:longitude"?: string;
    // Detailed Property Tag
    "og:street-address"?: string;
    // Detailed Property Tag
    "og:locality"?: string;
    // Detailed Property Tag
    "og:region"?: string;
    // Detailed Property Tag
    "og:postal-code"?: string;
    // Detailed Property Tag
    "og:country-name"?: string;

    // Maybe Tags
    // "og:type"?: string;
    // robots?: string;
};

const defaultTitle = "HomeShark — Be the Shark, Not the Bait.";

@Injectable({ providedIn: "root" })
export class SeoService {
    constructor(
        private meta: Meta,
        private title: Title
    ) {}

    addOrRemoveTagsAndTitle(config: SeoConfig): void {
        if (!config) config = {};
        this.title.setTitle(config.title || defaultTitle);

        this.addOrRemoveTag("subtitle", config.subtitle);
        this.addOrRemoveTag("description", config.description);
        this.addOrRemoveTag("url", config.url);
        this.addOrRemoveTag("og:title", config["og:title"]);
        this.addOrRemoveTag("og:description", config["og:description"]);
        this.addOrRemoveTag("og:url", config["og:url"]);
        this.addOrRemoveTag("keywords", config.keywords);
        this.addOrRemoveTag("subject", config.subject);
        this.addOrRemoveTag("topic", config.topic);
        this.addOrRemoveTag("summary", config.summary);

        // Detailed Property Tags

        this.addOrRemoveTag("og:image", config["og:image"]);
        this.addOrRemoveTag("og:latitude", config["og:latitude"]);
        this.addOrRemoveTag("og:longitude", config["og:longitude"]);
        this.addOrRemoveTag("og:street-address", config["og:street-address"]);
        this.addOrRemoveTag("og:locality", config["og:locality"]);
        this.addOrRemoveTag("og:region", config["og:region"]);
        this.addOrRemoveTag("og:postal-code", config["og:postal-code"]);
        this.addOrRemoveTag("og:country-name", config["og:country-name"]);
    }

    private addOrRemoveTag(
        key: string,
        value: string | Array<string>,
        delimiter: string = ", "
    ): void {
        if (value) {
            if (Array.isArray(value)) {
                this.meta.updateTag({
                    name: key,
                    content: value.join(delimiter),
                });
            } else {
                this.meta.updateTag({ name: key, content: value });
            }
        } else {
            this.meta.removeTag(`name="${key}"`);
        }
    }
}
